export const GOOGLE_MAPS_URL = "https://maps.google.com/?q=" as const;

export const buildGoogleMapsAddressURL = (fullAddress: string): string => {
  const trimmedAddress = fullAddress.trim();

  return trimmedAddress
    ? `${GOOGLE_MAPS_URL}${encodeURIComponent(trimmedAddress)}`
    : GOOGLE_MAPS_URL;
};
